"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(number, index) {
    return [
        ['すこし前', 'すぐに'],
        ['%s秒前', '%s秒以内'],
        ['1分前', '1分以内'],
        ['%s分前', '%s分以内'],
        ['1時間前', '1時間以内'],
        ['%s時間前', '%s時間以内'],
        ['1日前', '1日以内'],
        ['%s日前', '%s日以内'],
        ['1週間前', '1週間以内'],
        ['%s週間前', '%s週間以内'],
        ['1ヶ月前', '1ヶ月以内'],
        ['%sヶ月前', '%sヶ月以内'],
        ['1年前', '1年以内'],
        ['%s年前', '%s年以内'],
    ][index];
}
exports.default = default_1;
//# sourceMappingURL=ja.js.map